import { FilterOption, MultiDropOption } from '@Types/Form.types';
import { REPORT_FILTER_TYPE } from '@Utils/constants';
import { limitInputNumber } from '@Utils/input.utils';
import { Checkbox, DatePickerV2, FreeText, MultiSelectDropdown } from '@kg-internal/pv3-uikit';

import './FilterInput.scss';

type Props = {
  value: string[] | boolean | { startDate: Date; endDate: Date } | undefined;
  onChange: (value: string[] | boolean | { startDate: Date; endDate: Date }) => void;
  filterOption?: FilterOption;
  keywordInput: string;
  onKeywordChange: (keyword: string) => void;
  placeholder?: string;
};
const FilterInput = ({ value, onChange, filterOption, keywordInput, onKeywordChange, placeholder }: Props) => {
  const block = 'filter-input';

  switch (filterOption?.type) {
    case REPORT_FILTER_TYPE.KEYWORD: {
      let currentValues: MultiDropOption[] = [];
      if (Array.isArray(value)) {
        currentValues = value.map((v) => ({ label: v, value: v }));
      }
      return (
        <div className={`${block}__keywords-container`}>
          <MultiSelectDropdown
            label={filterOption.label}
            options={[]}
            values={currentValues}
            fullWidth
            allowAddNew
            placeholder={filterOption.placeholder}
            onChange={(keywords) => {
              onChange(keywords.map((k: MultiDropOption) => k.value));
              setTimeout(() => {
                const input = document.querySelector(`.${block} input`) as HTMLInputElement;
                input?.focus();
              }, 0);
            }}
            validateNewItem={(item) => (value ? !(value as string[]).includes(item) : true)}
          />
          <FreeText
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key === 'Enter' && e.currentTarget.value.trim()) {
                onChange([...currentValues.map((k) => k.value), e.currentTarget.value]);
                onKeywordChange('');
              } else if (filterOption.valueType === 'number') {
                limitInputNumber(e);
              }
            }}
            fullWidth
            value={keywordInput}
            onChange={(keyword) => onKeywordChange(keyword.target.value)}
            placeholder={placeholder}
            type={filterOption.valueType}
          />
        </div>
      );
    }
    case REPORT_FILTER_TYPE.BOOLEAN_TYPE: {
      return (
        <div className='content-left'>
          <Checkbox checked={!value ? false : (value as boolean)} onChange={(e) => onChange(e.target.checked)} />
          <p>{filterOption.label}</p>
        </div>
      );
    }
    case REPORT_FILTER_TYPE.CHECKBOX:
      return (
        <div className={`${block}__checkbox-group`}>
          {filterOption &&
            filterOption.options &&
            filterOption?.options.map((option) => (
              <div key={option} className={`${block}__checkbox-container`}>
                <Checkbox
                  checked={!value ? false : ((value as string[]).includes(option) as boolean)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      onChange([...((value as string[]) || []), option]);
                    } else {
                      onChange((value as string[]).filter((opt) => opt !== option));
                    }
                  }}
                />
                {option}
              </div>
            ))}
        </div>
      );
    case REPORT_FILTER_TYPE.DATE:
      return (
        <div className={`${block}__date-container`}>
          <DatePickerV2
            label="Start Date"
            id="Start Date"
            maxDate={value ? (value as { startDate: Date; endDate: Date }).endDate : undefined}
            value={value ? (value as { startDate: Date; endDate: Date }).startDate : undefined}
            onChange={(date) =>
              onChange({
                ...(value as { startDate: Date; endDate: Date }),
                startDate: date,
              })
            }
          />
          <DatePickerV2
            label="End Date"
            id="End Date"
            minDate={value ? (value as { startDate: Date; endDate: Date }).startDate : undefined}
            value={value ? (value as { startDate: Date; endDate: Date }).endDate : undefined}
            onChange={(date) =>
              onChange({
                ...(value as { startDate: Date; endDate: Date }),
                endDate: date,
              })
            }
          />
        </div>
      );
    default:
      return null;
  }
};

export default FilterInput;
